import React from "react";
import ReusableForm from "../Reusable/ReusableForm";
import { Button, Form, Input } from "antd";

const InputField = () => {
  const inputData = [
    {
      name: "firstName",
      label: "Firstname",
      type: "text",
      value: "",
    },
    {
      name: "lastName",
      label: "Lasstname",
      type: "text",
      value: "",
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      value: "",
    },
  ];
  return (
    <>
      <ReusableForm inputData={inputData}/>
    </>
  );
};

export default InputField;
